export enum MessageType  {
    RESPONSE_REQUIRED = "RESPONSE_REQUIRED",
    INFORMATIONAL = "INFORMATIONAL",
    RESPONSE_REQUIRED_AND_INFORMATIONAL = "RESPONSE_REQUIRED_AND_INFORMATIONAL",
    NONE = "NONE"
}
